import { render, staticRenderFns } from "./Totems.vue?vue&type=template&id=9ac49a88"
import script from "./Totems.vue?vue&type=script&lang=js"
export * from "./Totems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports